import { connect } from 'react-redux';
import TableContent from './TableContent';
import {
  getErrorMessage,
  getProductGroups,
} from '../../../../../../../../store/associations/selectors';
import { setErrorMessage } from '../../../../../../../../store/associations/actions';
import { setOpenModal } from '../../../../../../../../store/modals/actions';

const mapStateToProps = (state) => ({
  groups: getProductGroups(state),
  errorMessage: getErrorMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
  setErrorMessage: (errorMessage) => {
    dispatch(setErrorMessage(errorMessage));
  },

  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableContent);
